import React, { useState } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Alert, Button, ButtonGroup } from 'react-bootstrap';

const EmisorSelector = ({ name, value, onChange }) => {
  const [current, setCurrent] = useState(value || {});

  const handleChange = (change) => {
    const newChange = { ...change };
    setCurrent(newChange);
    onChange({ [name]: newChange });
  };

  return (
    Guardian.allows('sector_primario.access') && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>
          <ButtonGroup aria-label="Basic example">
            <Button
              variant={Object.keys(current).length === 0 ? 'primary' : 'secondary'}
              onClick={() => handleChange(null)}
            >
              Emisor
            </Button>
            <Button
              variant={current?.adquiriente ? 'primary' : 'secondary'}
              onClick={() => handleChange({ adquiriente: true })}
            >
              Adquiriente
            </Button>
            <Button
              variant={current?.productor ? 'primary' : 'secondary'}
              onClick={() => handleChange({ productor: true })}
            >
              Productor
            </Button>
          </ButtonGroup>
        </div>

        {Object.keys(current).length === 0 && (
          <Alert variant="info">
            Si eres <strong>persona física o moral</strong>.
          </Alert>
        )}

        {current?.adquiriente && (
          <Alert variant="info">
            Si eres persona <strong>física o moral</strong> y realizas actividades del <strong>Sector Primario</strong>.
          </Alert>
        )}

        {current?.productor && (
          <Alert variant="info">
            Si emites facturas electrónicas a través del <strong>adquirente de tus productos.</strong>
          </Alert>
        )}
      </div>
    )
  );
};

export default EmisorSelector;
